import { render, staticRenderFns } from "./BlockPayment.vue?vue&type=template&id=33f6a9e4&scoped=true&"
import script from "./BlockPayment.vue?vue&type=script&lang=js&"
export * from "./BlockPayment.vue?vue&type=script&lang=js&"
import style0 from "./BlockPayment.vue?vue&type=style&index=0&id=33f6a9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6a9e4",
  null
  
)

export default component.exports